import axios from "@/axios";

export const namespaced = true;

const defaultData = {
    orderId: 0,
    name: null,
    address: null,
    accountNumber: null,
    internationalBankAccountNumber_IBAN: null,
    swiftAba: null,
    billingDate: null,
    paymentDueDate: null
}

export const state = {
    bankingInfo: Object.assign({}, defaultData),
    status: false,
    bankingInfoErrors: []
};

export const getters = {
    bankingInfo: state => {
        return state.bankingInfo;
    },
    bankingInformationStatus: state => {
        return state.status
    },
    bankingInfoErrors:state => state.bankingInfoErrors
};

export const mutations = {
    SET_BANKING_INFO(state, response) {
        state.bankingInfo = Object.assign({}, defaultData, response.data)
    },
    SET_STATUS(state, status) {
        state.status = status;
    },
    CLEAR_DATA(state) {
        state.bankingInfo = Object.assign({}, defaultData)
    },
    SET_ERRORS(state, data) {
        state.bankingInfoErrors = data;
      },
      CLEAR_ERRORS(state) {
          state.bankingInfoErrors = [];
      },
      SET_BANK_INFORMATION(state, data) {
          state.bankingInfo.name = data.bankName;
          state.bankingInfo.address = data.bankAddress;
          state.bankingInfo.accountNumber = data.accountName;
          state.bankingInfo.internationalBankAccountNumber_IBAN = data.iban;
          state.bankingInfo.swiftAba = data.swift;
        }
};

export const actions = {
    clearData({ commit }) {
        commit('CLEAR_DATA');
    },
    setBankingInformation({commit}, data) {
        commit("SET_BANK_INFORMATION", data);
    },
    async getBankingInformationStatus({ commit }, id) {
        if (id == 0) {
            commit("SET_STATUS", false);
        } else {
            return await axios.get('/api/orderbanking/order/status/' + id)
                .then(({ data }) => {
                    if(data && data.length === 0) {
                        commit("SET_STATUS", true);
                        commit("CLEAR_ERRORS");
                    } else {
                      commit("SET_STATUS", false);
                        commit("SET_ERRORS", data);
                    }
                })
        }
    },
    async loadBankingInformation({ commit }, orderId) {
        try {
            commit("SET_BANKING_INFO", await axios.get(`/api/orderbanking/${orderId}`));
        }
        catch (error) {
            console.log("ERROR LOADING BANKING INFORMATION: ", error); //not handelled
        }
    },
    async saveBankingInfoToServer({ commit, state, dispatch }, orderId) {
        return new Promise((resolve, reject) => {
            state.bankingInfo.orderId = orderId

            axios.post("/api/orderbanking", state.bankingInfo)
                .then((response) => {
                    return resolve();
                })
                .catch(function (error) {
                    resolve()
                    return reject("Please complete or clear all banking information before proceeding. Partial banking information will not be saved.");
                })
        });
    }
};